import axios, { AxiosResponse } from 'axios'

const sendNGWordCheck = (sentence: any): Promise<AxiosResponse> => axios.post(`ngword_check`, sentence, { skipAuth: true } as any)

const getCSRFToken = (): Promise<AxiosResponse> => axios.get(`/generate_token`)
const sendTestPhoneNumber = (phone_number: any): Promise<AxiosResponse> => axios.post(`two_factor_authentication/test`, phone_number, { skipAuth: true } as any)

const commonService = {
  sendNGWordCheck,
  getCSRFToken,
  sendTestPhoneNumber,
}

export default commonService
